'use strict';

/** @type {import('./floor')} */
module.exports = Math.floor;



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-intrinsics/floor.js
// module id = 614
// module chunks = 0